import { useState, useEffect } from "react";

const STEPS = [
  {
    key: "connect",
    icon: "🔗",
    title: "Step 1 — Connect a social account",
    desc: "Link your Facebook, Twitter, or LinkedIn to start posting.",
    tab: "social-media",
    cta: "Go to Social Media",
  },
  {
    key: "generate",
    icon: "✍️",
    title: "Step 2 — Generate your first post",
    desc: "Enter a topic and let Kronos AI write and design your content.",
    tab: "social-media",
    cta: "Generate Content",
  },
  {
    key: "proposal",
    icon: "📄",
    title: "Step 3 — Set up your freelancer profile",
    desc: "Add your skills so Kronos writes winning proposals tailored to you.",
    tab: "proposals",
    cta: "Set Up Profile",
  },
];

export default function OnboardingBanner({ onNavigate }) {
  const [dismissed, setDismissed] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const done = localStorage.getItem("kronos_onboarding_done");
    if (done) setDismissed(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem("kronos_onboarding_done", "1");
    setDismissed(true);
  };

  if (dismissed) return null;

  const step = STEPS[currentStep];

  return (
    <div className="mb-4 rounded-lg border border-purple-500/20 bg-gradient-to-r from-purple-950/40 via-indigo-950/30 to-cyan-950/30 px-4 py-3">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3 flex-1">
          <span className="text-2xl mt-0.5">{step.icon}</span>
          <div className="flex-1">
            <p className="text-sm font-bold text-white">{step.title}</p>
            <p className="text-xs text-gray-400 mt-0.5">{step.desc}</p>
            <div className="flex items-center gap-2 mt-3 flex-wrap">
              <button
                onClick={() => { onNavigate && onNavigate(step.tab); }}
                className="px-3 py-1.5 rounded-lg bg-gradient-to-r from-purple-600 to-cyan-600 text-white text-xs font-bold hover:opacity-90 transition-all"
              >
                {step.cta}
              </button>
              {currentStep < STEPS.length - 1 && (
                <button
                  onClick={() => setCurrentStep(s => s + 1)}
                  className="px-3 py-1.5 rounded-lg bg-white/5 border border-white/10 text-gray-300 text-xs hover:bg-white/10 transition-all"
                >
                  Next tip →
                </button>
              )}
              <button
                onClick={dismiss}
                className="text-xs text-gray-500 hover:text-gray-300 transition-colors ml-1"
              >
                Dismiss
              </button>
            </div>
          </div>
        </div>
        {/* Step dots */}
        <div className="flex gap-1 mt-1">
          {STEPS.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentStep(i)}
              className={`w-2 h-2 rounded-full transition-all ${i === currentStep ? "bg-purple-400 w-4" : "bg-white/20 hover:bg-white/40"}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
